import type { IContextQueryResult } from '@modules/core/services/query/types';
import { DEFAULT_TIMEOUT } from '@modules/core/services/api/constants';
import { useContextQuery } from '@modules/core/services/query';
import { promiseTimeout } from '@utils/promises';

import type { IStatFileData } from '../types';
import {
  LOCAL_STAT_FILE_QUERY_KEY,
  REQUEST_INTERVAL,
} from '../constants';

export default function useNewVersionTimestampQuery(): IContextQueryResult<IStatFileData, Error, string> {
  return useContextQuery<IStatFileData, Error, string>({
    queryKey: [LOCAL_STAT_FILE_QUERY_KEY],
    queryFn: async () => {
      const response = await promiseTimeout({
        promise: fetch(`${window.location.origin}/_stat.json?time=${Date.now()}`, { cache: 'no-store' }),
        timeout: DEFAULT_TIMEOUT,
        error: () => new Error('Failed to fetch _stat'),
      });
      return await response.json() as IStatFileData;
    },
    select: (data) => data?.timestamp,
    enabled: import.meta.env.PROD,
    refetchInterval: REQUEST_INTERVAL,
    refetchOnMount: false,
    refetchIntervalInBackground: true,
  });
}
